import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            海量内容<span className="text-accent-500">分类</span>，随心选择
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            六大内容频道，覆盖影视、动漫、综艺、纪录片等全品类资源
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-2xl h-64 cursor-pointer"
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500/90 text-background-50">
                    <i className={`${cat.icon} text-sm`}></i>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-white">{cat.name}</h3>
                </div>
                <p className="text-sm text-white/70 mb-2 line-clamp-2">{cat.description}</p>
                <span className="text-xs text-white/50">{cat.count.toLocaleString()} 部资源</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}